import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import md5Hex from "md5-hex";
import Api from "../Api/Api.json";
import { InstallApk } from "../components/InstallAPK";
import "../styles/global.css";
import { Box, Button, TextField } from "@mui/material";
import "./login.css";

const LoginPage = ({ onLogin }) => {
	var [userType, setUserType] = useState("");
	var [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const [isLoggingIn, setIsLoggingIn] = useState(false);
	useEffect(() => {
		if (localStorage.getItem("user_info") !== null) {
			//InstallApk();
			console.log("inside login page");
			navigate("/landing/rpm_list");
		}
	}, []);

	const handleSubmit = () => {
		navigate("/Landing");
	};

	//call login check api
	const handleLogin = async (e) => {
		e.preventDefault(); // Prevent default form submission behavior
		console.log("in handle login");
		setIsLoggingIn(true);
		// Perform validation here if needed
		if (username.trim() !== "" && password.trim() !== "") {
			console.log(username.substring(0, 1));
			if (username.substring(0, 1) === "0") {
				console.log(username.substring(1));
				setUsername(username.substring(1));
				username = username.substring(1);
			}
			console.log(username);
			const headers = { headers: { "Content-Type": "application/json" } };
			//url and task different for different users
			const url = Api.TELEDOC_PROVIDER_API;
			const requestData = {
				task: "authenticateProvider",
				phone: username,
				password: md5Hex(password),
			};

			try {
				const response = await axios.post(url, requestData, headers);
				console.log(response.data);
				if (response.data.length > 0) {
					//onLogin(username);
					//navigate different for different users
					navigate("/landing/rpm_list");
					console.log(response.data[0]);
					localStorage.setItem(
						"user_info",
						JSON.stringify(response.data[0])
					);
				}
			} catch (error) {
				console.log(error);
			}
		} else {
			setError("Invalid username or password");
		}
		setIsLoggingIn(false);
	};

	return (
		<div
			className="h-100 w-100 loginBglight px-3 flex flex-col md:flex-row"
			style={{ height: "calc(100vh - 16px)" }}
		>
			<div className="w-1/2 hidden md:flex flex-col max-h-full">
				<div className="h-[10%]">
					<img
						src="/images/logo-white.png"
						className="h-[100%]"
						alt=""
					/>
				</div>
				<div className="h-full flex justify-end">
					<img src="/images/login-bg.svg" className="w-100" alt="" />
				</div>
			</div>
			<div className="w-full md:w-1/2 bg-white rounded-3xl h-full">
				<div className="flex items-center justify-center h-full">
					<div className="maxWidth">
						<h1 className="text-center">Semion Healthpal</h1>
						<p className="text-center mb-5">
							Please fill in your login and password to get
							started
						</p>
						<form onSubmit={handleLogin} style={{ width: "100%" }}>
							<div class="mb-3">
								<label
									for="exampleFormControlInput1"
									class="form-label"
								>
									Userid (phone/semion id)
								</label>
								<input
									type="text"
									class="form-control"
									id="exampleFormControlInput1"
									value={username}
									onChange={(e) =>
										setUsername(e.target.value)
									}
									variant="outlined"
								/>
							</div>
							<div class="mb-3">
								<label
									for="exampleFormControlInput1"
									class="form-label"
								>
									password
								</label>
								<div className="position-relative">
									<img
										src="/images/eys.png"
										className="position-absolute eysSet"
										alt=""
									/>
									<input
										type="text"
										class="form-control"
										id="exampleFormControlInput1"
										value={password}
										onChange={(e) =>
											setPassword(e.target.value)
										}
										variant="outlined"
									/>
								</div>
							</div>
							<div className="d-flex justify-content-between">
								<div class="form-check lh-1">
									<input
										class="form-check-input"
										type="checkbox"
										value="remember"
										id="flexCheckDefault"
									/>
									<label
										class="form-check-label"
										for="flexCheckDefault"
									>
										Remember me
									</label>
								</div>
								<a href="#">Forgot Password?</a>
							</div>
							<div className="w-100">
								<button
									type="submit"
									className={`btn btn-primary w-100 mt-4 py-3 flex 
									flex-row justify-center items-center gap-2 !text-base ${
										isLoggingIn ? "loading" : ""
									}`}
								>
									{/* {isLoggingIn ? (
										<div className="flex justify-center items-center">
											<div className="w-5 h-5 border-3 border-t-3 border-t-white border-gray-400 rounded-full animate-spin"></div>
											<span className="sr-only">
												Loading...
											</span>
										</div>
									) : (
										<>Login</>
									)} */}
									Login
								</button>
							</div>
							<div className="mt-5 text-center">
								<p>
									Don’t have an account?{" "}
									<a
										href="#"
										onClick={() =>
											navigate("/registration")
										}
									>
										Sign up
									</a>
								</p>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LoginPage;

{
	/* <div
	style={{
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "calc(100vh - 16px)",
		flexDirection: "column",
	}}
>
	<h2>Login to Semion Health Pal</h2>
	<form onSubmit={handleLogin} className="flex flex-col gap-3">
		<TextField
			fullWidth
			label="Userid (phone/semion id):"
			type="text"
			id="username"
			value={username}
			onChange={(e) => setUsername(e.target.value)}
			required
			variant="outlined"
			size="small"
			multiline
			rows={1}
		/>
		<TextField
			fullWidth
			label="Password"
			id="password"
			type="password"
			value={password}
			onChange={(e) => setPassword(e.target.value)}
			required
			variant="outlined"
			size="small"
			multiline
			rows={1}
		/>
		<Box className="flex flex-col gap-2">
			<Button type="submit" variant="contained" fullWidth>
				Login
			</Button>
			<Button
				variant="outlined"
				color="success"
				onClick={() => navigate("/registration")}
				fullWidth
			>
				Don't have an account? Register
			</Button>
		</Box>
	</form>
</div>; */
}
